import * as i0 from '@angular/core';
import * as i1 from './button.module';
import * as i2 from '@angular/common';
import * as i3 from './button.component';
export const BllButtonModuleNgFactory:i0.NgModuleFactory<i1.BllButtonModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.bllButton = (<any>(null as any));
var _decl0_12:i3.uiAnchor = (<any>(null as any));
var _decl0_13:i2.AsyncPipe = (<any>(null as any));
var _decl0_14:i2.UpperCasePipe = (<any>(null as any));
var _decl0_15:i2.LowerCasePipe = (<any>(null as any));
var _decl0_16:i2.JsonPipe = (<any>(null as any));
var _decl0_17:i2.SlicePipe = (<any>(null as any));
var _decl0_18:i2.DecimalPipe = (<any>(null as any));
var _decl0_19:i2.PercentPipe = (<any>(null as any));
var _decl0_20:i2.TitleCasePipe = (<any>(null as any));
var _decl0_21:i2.CurrencyPipe = (<any>(null as any));
var _decl0_22:i2.DatePipe = (<any>(null as any));
var _decl0_23:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_24:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_25:i2.KeyValuePipe = (<any>(null as any));
var _decl0_26:i2.CommonModule = (<any>(null as any));
var _decl0_27:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_28:i0.ElementRef<any> = (<any>(null as any));
function _View_bllButton_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const currVal_1:any = (!_decl0_11.outline && !_decl0_11.flat);
  currVal_1;
  const currVal_2:any = _decl0_11.outline;
  currVal_2;
  const currVal_3:any = _decl0_11.flat;
  currVal_3;
  const currVal_4:any = _decl0_11.expand;
  currVal_4;
  const currVal_5:any = _decl0_11.icon;
  currVal_5;
  const currVal_6:any = (_decl0_11.disabled || null);
  currVal_6;
}
function _View_bllButton_1_1():void {
  if (_decl0_11.icon) {
    var _any:any = (null as any);
    const currVal_0:any = 'bll-button-icon';
    currVal_0;
    const currVal_1:any = ('icon-' + _decl0_11.icon);
    currVal_1;
  }
}
function _View_bllButton_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.icon;
  currVal_0;
}
function _View_uiAnchor_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = true;
  currVal_0;
  const currVal_1:any = (_decl0_12.disabled? (-1): (_decl0_12.tabIndex || 0));
  currVal_1;
  const currVal_2:any = (_decl0_12.disabled || null);
  currVal_2;
  const currVal_3:any = (_decl0_12.disabled? _decl0_12.disabled.toString(): 'false');
  currVal_3;
  const pd_4:any = ((<any>_decl0_12._haltDisabledEvents(_any)) !== false);
}
function _View_uiAnchor_2_1():void {
  if (_decl0_12.icon) {
    var _any:any = (null as any);
    const currVal_0:any = 'bll-button-icon';
    currVal_0;
    const currVal_1:any = ('icon-' + _decl0_12.icon);
    currVal_1;
  }
}
function _View_uiAnchor_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.icon;
  currVal_0;
}
